import clientCredentials from "./clientCredentials/clientCredentials";
import codeGrant from "./codeGrant/codeGrant1";
import codeGrant2 from "./codeGrant/codeGrant2";
import codeGrant3 from "./codeGrant/codeGrant3";
import codeGrantRecovery from "./codeGrant/codeGrantRecovery";
import implicitGrant from "./implicitGrant/implicitGrant1";
import implicitGrant2 from "./implicitGrant/implicitGrant2";

export default {
  ...clientCredentials,
  ...codeGrant,
  ...codeGrant2,
  ...codeGrant3,
  ...codeGrantRecovery,
  ...implicitGrant,
  ...implicitGrant2
};
